import { mdlStatus } from "./CompAttachmentsMdl";

export class mdlGetClaimStatusNewRes {
    st: mdlStatus;
    ClaimNoList: mdlClaimStatusNew[];
    ClaimStatusList: mdlClaimStatusNew[];
    DocumentList: mdlCliamDocumentListNew[];
}

export class mdlClaimStatusNew {
    ROW_NUM: number|null;
    STEPS: string;
    POLICY_NO: string;
    SEQUENCE_NO: string;
    INSURED_MOBILE_NO: string;
    CLAIM_NUMBER: string;
    SUB_CLAIM_NUMBER: string;
    CLAIM_TYPE: string;
    ACCIDENT_DATE: string;
    LIABILITY: string;
    RECEIVED_FROM: string;
    STATUS: string;
    STATUS_DATE: string;
    TP_MOBILE_NO: string;
    TP_SEQUENCE_NUMBER: string;
    COMMENT: string;
    StatusDesc: string;
}

export class mdlClaimNoListNew {
    ROW_NUM: number|null;
    STEPS: string;
    POLICY_NO: string;
    SEQUENCE_NO: string;
    INSURED_MOBILE_NO: string;
    CLAIM_NUMBER: string;
    SUB_CLAIM_NUMBER: string;
    CLAIM_TYPE: string;
    ACCIDENT_DATE: string;
    LIABILITY: string;
    RECEIVED_FROM: string;
    STATUS: string;
    STATUS_DATE: string;
    TP_MOBILE_NO: string;
    TP_SEQUENCE_NUMBER: string;
    COMMENT: string;
}

export class mdlCliamDocumentListNew {
    ROW_NUM: string;
    CLAIM_NUMBER: string;
    SUB_CLAIM_NUMBER: string;
    CLAIM_TYPE: string;
    DOC_NAME_EN: string;
    DOC_NAME_BL: string;
    SMS_STATUS: string;
}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlGetClaimStatusNewRes.ts